var map = {
	"./Zimi-logo.png": "f2d5",
	"./auddio.png": "5bae",
	"./axios-logo.png": "de81",
	"./bard.svg": "180d",
	"./bigscoot.png": "7cd6",
	"./bling.png": "c4af",
	"./capture-proof.png": "fbe9",
	"./cayka-logo.png": "ea1c",
	"./chatgpt.svg": "7027",
	"./conducktor.png": "033c",
	"./esgtree.png": "2ebb",
	"./finance.png": "6232",
	"./gtensor-logo.png": "69dc",
	"./klugar-logo.png": "53fa",
	"./kolai.png": "449b",
	"./lightadison.png": "9b86",
	"./listen.png": "1e30",
	"./llma.svg": "d502",
	"./lums.png": "7677",
	"./magik.png": "fa19",
	"./media.png": "2d7a",
	"./open-ai.svg": "c099",
	"./playground.png": "34aa",
	"./premiro.png": "3b85",
	"./primal.png": "3b8c",
	"./sereniby.png": "a91a",
	"./simiconnect.png": "5dc5",
	"./smart-interview.png": "4b70",
	"./uni.png": "055b",
	"./znapshot.png": "3e82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d27";